<template>
  <div>
    <groups ref="groups" :pageType="pageType" />
    <license-modal @hasUpdate="handleUpdate" />
    <group-modal @hasUpdate="handleUpdate">
      <b-tab title="Add Pools" v-if="!isMember">
        <add-pools-form :group="selectedGroup" @hasUpdate="handleUpdate" />
      </b-tab>
    </group-modal>
  </div>
</template>

<script>
import LicenseModal from '../components/Modals/LicenseModal.vue';
import GroupModal from '../components/Modals/GroupModal.vue';
import AddPoolsForm from '../components/Forms/AddPoolsForm.vue';
import Groups from '../components/Groups.vue';
import config from '../constants/config';
import { mapGetters } from 'vuex';

export default {
  components: {
    LicenseModal,
    GroupModal,
    Groups,
    AddPoolsForm
  },
  methods: {
    handleUpdate() {
      this.$refs.groups.fetchGroups();
    }
  },
  computed: {
    ...mapGetters('group', ['selectedGroup']),
    ...mapGetters('user', ['isMember']),
    pageType() {
      return config.LICENSES_PAGE;
    }
  }
};
</script>
